export default __webpack_public_path__ + "static/media/ss_l.d2fbe4d8.wav";